import Entity from '../../../core/domain/entity';
import UniqueEntityID from '../../../core/domain/unique_entity_id';

export interface UrlTargetingProps {
  url: string;
  label: string;
  target: string;
}

export class UrlTargetingId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): UrlTargetingId {
    return new UrlTargetingId(id);
  }
}

export class UrlTargeting extends Entity<UrlTargetingProps> {
  get urlTargetingId(): UrlTargetingId {
    return UrlTargetingId.create(this.id);
  }

  get url() {
    return this.props.url;
  }

  get label() {
    return this.props.label;
  }

  get target() {
    return this.props.target;
  }

  private constructor(props: UrlTargetingProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: UrlTargetingProps): UrlTargeting {
    return UrlTargeting.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(
    props: UrlTargetingProps,
    id?: UniqueEntityID,
  ): UrlTargeting {
    return new UrlTargeting(props, id);
  }
}
